import React from "react";

export const GenericButton = ({ onClick, text, disabled, classes }) => {
	const c = classes || "";

	return (
		<button
			onClick={onClick}
			className={`generic-button block ${
				disabled ? "opacity-25 defaultCursor" : "pointerCursor"
			} ${c}`}
			disabled={disabled}
		>
			{text}
		</button>
	);
};
